import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=3737ae20&scoped=true&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=3737ae20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3737ae20",
  null
  
)

export default component.exports